export default __webpack_public_path__ + "static/media/katalonLogo.663bfb78.svg";